import { Box, H3 } from '@ouster/webviz-react-components';

import { Link } from 'react-router-dom';
import { buildTalkToSalesLink } from 'src/utils/talkToSales';

import demoStyles from '../../pages/public/inAppDemo.module.css';
import { getInAppDemoBackgroundStyle } from '../../pages/public/inAppDemoThumbnails';
import styles from '../../pages/PublicPage.module.css';

export default function PublicPartnerPreviewContent({
  isPrivate,
}: {
  isPrivate?: boolean;
}) {
  return (
    <Box
      className={`${demoStyles['page-content']}`}
      data-testid="public-partner-preview-content-root"
    >
      <Box className={demoStyles['text-area']}>
        {/* brief */}
        <Box className={`${demoStyles.brief}`}>
          <p>
            As an Ouster partner, early access is available to cutting-edge
            features and specialized lidar data before public release. This
            partner-exclusive insight helps accelerate development and stay
            ahead of the market. <strong>Unlock what’s next in lidar</strong>.
          </p>
          <Link
            to={buildTalkToSalesLink('Public Partner Preview')}
            target="_blank"
            rel="noopener noreferrer"
            className={`${styles['primary-button']} ${styles['get-start-button']}`}
            style={{
              width: 'max-content',
              fontWeight: 500,
              padding: '18px 36px',
            }}
          >
            Contact an Ouster Sales Representative
          </Link>
        </Box>

        {/* go public */}
        <Box className={`${demoStyles.brief}`}>
          <H3 fontSize={24} fontWeight="medium">
            Visualize Lidar’s potential: Get a glimpse of Ouster Studio
          </H3>
          <p>
            While this section is reserved for partners, the visualization on
            the right demonstrates the powerful capabilities of Ouster Studio.
            Partners can access an expanded library of datasets, beta features,
            and direct collaboration for application-specific solutions.
          </p>
          <Link
            to={
              isPrivate
                ? '/drive/sample_library/public_collection'
                : '/public/sample_library/public_collection'
            }
            className={`${styles['primary-button']} ${styles['get-start-button']}`}
            style={{
              width: 'max-content',
              fontWeight: 500,
              padding: '18px 36px',
            }}
          >
            Explore Public Sample Data
          </Link>
        </Box>
      </Box>

      <Box
        className={`${demoStyles['image-area']}`}
        style={getInAppDemoBackgroundStyle('share_from_bg.png')}
      />
    </Box>
  );
}
